interface ICreateNewbuildingProductArguments {
  id: number;
  position: number;
  extra?: object;
  name: string;
  isReliable: boolean;
  developerId: number[];
  isKpn: boolean;
  regionId: number;
}

export function createNewbuildingProduct({
  id,
  position,
  extra,
  name,
  isReliable,
  developerId,
  isKpn,
  regionId,
}: ICreateNewbuildingProductArguments) {
  return {
    id,
    offerType: 'JK',
    position,
    extra,
    dealType: 'sale',
    objectType: 'JK',
    name,
    nv: isReliable,
    ownerType: 'developer',
    ownerId: developerId,
    consultant: isKpn,
    city_id: regionId,
  };
}
